import type { IntentController } from '@jet/environment/dispatching';
import type { ObjectGraph } from '@jet/environment/dependencies';
import type { SectionChangeInstruction } from '../../../models/invalidation/change-instruction/SectionChangeInstruction';
import {
    makeRefreshRecentlyPlayedIntent,
    type RefreshRecentlyPlayedIntent,
} from './RefreshRecentlyPlayedIntent';
import { requestViewPageWithQuery } from '@jet-app/music-classical/api/request-view-page';
import { Logger } from '../../../dependencies/logger';
import {
    buildHomePageSections,
    recentlyPlayedInvalidationRules,
} from '../utils';

export const RefreshRecentlyPlayedIntentController: IntentController<RefreshRecentlyPlayedIntent> =
    {
        $intentKind: 'RefreshRecentlyPlayedIntent',
        async perform(
            intent: RefreshRecentlyPlayedIntent,
            objectGraph: ObjectGraph,
        ): Promise<SectionChangeInstruction> {
            Logger.log(
                objectGraph,
                `Refreshing Recently Played for reason "${intent.reason}".`,
            );
            const userResponse = await requestViewPageWithQuery(
                intent.refreshPath,
                objectGraph,
                { 'force-auth-header': 'true' },
            );

            const sections = buildHomePageSections(
                userResponse.body.sections as any,
                objectGraph,
                {
                    eventTriggers: [
                        recentlyPlayedInvalidationRules(
                            makeRefreshRecentlyPlayedIntent(
                                intent.refreshPath,
                                'playActivity',
                            ),
                        ),
                    ],
                },
            );

            return {
                instruction: {
                    instruction: 'replaceSection',
                    newSection: sections[0],
                },
            };
        },
    };
